import { getApiUrl } from './apiBaseUrl'

async function deleteRequest(url = '', data = {}) {
  const response = await fetch(getApiUrl(url), {
    method: 'DELETE',
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json'
    },
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
    body: JSON.stringify(data)
  })
  return response.json()
}

export default deleteRequest
